import { render, staticRenderFns } from "./SignViaMobile.vue?vue&type=template&id=b916fa94&scoped=true&"
import script from "./SignViaMobile.vue?vue&type=script&lang=js&"
export * from "./SignViaMobile.vue?vue&type=script&lang=js&"
import style0 from "./SignViaMobile.vue?vue&type=style&index=0&id=b916fa94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b916fa94",
  null
  
)

export default component.exports